/**
 * BlockTabs.jsx
 * Created by Destin Frasier on 11/09/17.
 */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    activeIndex: PropTypes.number,
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.element
    ]).isRequired,
    selectedIndexChanged: PropTypes.func,
    indentTabs: PropTypes.bool
};

const defaultProps = {
    activeIndex: 0,
    indentTabs: false
};

export default class BlockTabs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeIndex: this.props.activeIndex
        };

        this._renderTabButtons = this._renderTabButtons.bind(this);
        this._renderTabPanels = this._renderTabPanels.bind(this);
        this.handleTabClick = this.handleTabClick.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.activeIndex !== nextProps.activeIndex) {
            this.setState({ activeIndex: nextProps.activeIndex });
        }
    }

    handleTabClick(e, activeIndex) {
        e.preventDefault();
        this.setState({ activeIndex }, () => {
            // Callback once state has been updated
            if (this.props.selectedIndexChanged) {
                this.props.selectedIndexChanged(activeIndex);
            }
        });
    }

    _renderTabButtons() {
        return this.props.children
            .map((child, index) => {
                const tabID = index;
                const selected = tabID === this.state.activeIndex;
                const className = selected ? 'rec-block-tab rec-block-tab-active' : 'rec-block-tab';

                return (
                    <li
                        key={`tab-${tabID}`}
                        className={className}
                        role="presentation">
                        <button
                            role="tab"
                            aria-selected={selected}
                            onClick={(event) => this.handleTabClick(event, index)}>
                            {child.props.label}
                        </button>
                    </li>
                );
            });
    }

    _renderTabPanels() {
        return this.props.children
            .map((child, index) => {
                const tabID = index;
                const selected = tabID === this.state.activeIndex;

                let hidden = 'hide';
                if (selected) {
                    hidden = '';
                }

                return (
                    <div
                        {...child.props}
                        key={`tab-panel-${tabID}`}
                        role="tabpanel"
                        aria-hidden={!selected}
                        className={hidden}>
                        {child.props.children}
                    </div>
                );
            });
    }

    render() {
        const buttons = this._renderTabButtons();
        const panels = this._renderTabPanels();

        const indentClass = this.props.indentTabs ? 'rec-tab-indent' : '';

        return (
            <div className={`rec-block-tab-list ${indentClass}`}>
                <ul
                    className="rec-block-tabs"
                    role="tablist">
                    {buttons}
                </ul>
                {panels}
            </div>
        );
    }
}

BlockTabs.propTypes = propTypes;
BlockTabs.defaultProps = defaultProps;
